import React from 'react';
import PropTypes from 'prop-types';
import { Container, Input, InputGroupAddon } from '@sm/wds-react';
import { ChoiceOptions } from './ChoiceOptions';

export const QuizChoice = ({
  index,
  readOnlySurvey,
  questionId,
  answersLength,
  answer,
  moveAnswer,
  deleteAnswer,
  handleAnswerChange,
  handleScoreChange,
}) => (
  <Container
    data-testid={`QuizChoice_Container_${index}`}
    key={`question_${questionId}_${index + 1}`}
    className="sm-new-survey__quiz-choice-container"
    mb={4}
  >
    <div className="wds-flex">
      <Container className="sm-new-survey__choice-container wds-flex__item--grow wds-p-1">
        <Input
          id={`question-${questionId}-answer${index + 1}`}
          className="sm-new-survey__choice-input sm-new-survey__input"
          stretched
          size="sm"
          value={answer.answer}
          placeholder="Enter choice"
          label={index === 0 ? 'Choices' : undefined}
          onChange={event => handleAnswerChange(index, event)}
          disabled={readOnlySurvey}
        />
      </Container>
      <Container className="sm-new-survey__choice-container wds-p-1">
        <Input
          id={`question-${questionId}-score${index + 1}`}
          className="sm-new-survey__choice-input sm-new-survey__input"
          stretched
          size="sm"
          value={answer.score}
          placeholder="0"
          label={index === 0 ? 'Score' : undefined}
          onChange={event => handleScoreChange(index, event)}
          disabled={readOnlySurvey}
        />
      </Container>
      <Container className="sm-new-survey__choice-container wds-p-1">
        <InputGroupAddon>
          <ChoiceOptions
            index={index}
            questionAnswersLength={answersLength}
            moveAnswer={moveAnswer}
            deleteAnswer={deleteAnswer}
          />
        </InputGroupAddon>
      </Container>
    </div>
  </Container>
);

QuizChoice.propTypes = {
  index: PropTypes.number,
  readOnlySurvey: PropTypes.bool,
  questionId: PropTypes.string,
  answersLength: PropTypes.number,
  answer: PropTypes.shape({
    answer: PropTypes.string,
    score: PropTypes.string,
  }),
  moveAnswer: PropTypes.func,
  deleteAnswer: PropTypes.func,
  handleAnswerChange: PropTypes.func,
  handleScoreChange: PropTypes.func,
};

QuizChoice.defaultProps = {
  index: 0,
  readOnlySurvey: false,
  questionId: '',
  answersLength: 0,
  answer: {
    answer: '',
    score: '',
  },
  moveAnswer: () => {},
  deleteAnswer: () => {},
  handleAnswerChange: () => {},
  handleScoreChange: () => {},
};

export default QuizChoice;
